/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationResponse,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslationPathParams,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslation400,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslation401,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslation404,
  PostApiV1ExamRevisionLangBotexamlangidFinishTranslation500,
} from "../../types/examRevisionController/PostApiV1ExamRevisionLangBotexamlangidFinishTranslation.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1ExamRevisionLangBotexamlangidFinishTranslation } from "../../clients/examRevisionController/postApiV1ExamRevisionLangBotexamlangidFinishTranslation.ts";

export const postApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationKey =
  () =>
    [
      { url: "/api/v1/exam/revision/lang/:botExamLangId/finish-translation" },
    ] as const;

export type PostApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationKey =
  ReturnType<
    typeof postApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationKey
  >;

export function postApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    postApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationKey();
  return mutationOptions<
    PostApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation400
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation401
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation404
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation500
    >,
    {
      botExamLangId: PostApiV1ExamRevisionLangBotexamlangidFinishTranslationPathParams["botExamLangId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ botExamLangId }) => {
      return postApiV1ExamRevisionLangBotexamlangidFinishTranslation(
        botExamLangId,
        config,
      );
    },
  });
}

/**
 * @description Marca todas as questões do idioma informado como Revisadas, atualiza o status do idioma para Reviewed e recalcula o status geral da prova: se todos os idiomas estiverem Reviewed o BotExam passa para Reviewed, caso contrário permanece em PendingTranslation. **(Requer Authorization para autenticação)**
 * @summary Finalizar tradução de idioma de prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/lang/:botExamLangId/finish-translation}
 */
export function usePostApiV1ExamRevisionLangBotexamlangidFinishTranslation<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation400
        | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation401
        | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation404
        | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation500
      >,
      {
        botExamLangId: PostApiV1ExamRevisionLangBotexamlangidFinishTranslationPathParams["botExamLangId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationKey();

  const baseOptions =
    postApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation400
        | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation401
        | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation404
        | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation500
      >,
      {
        botExamLangId: PostApiV1ExamRevisionLangBotexamlangidFinishTranslationPathParams["botExamLangId"];
      },
      TContext
    >;

  return useMutation<
    PostApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation400
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation401
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation404
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation500
    >,
    {
      botExamLangId: PostApiV1ExamRevisionLangBotexamlangidFinishTranslationPathParams["botExamLangId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1ExamRevisionLangBotexamlangidFinishTranslationMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation400
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation401
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation404
      | PostApiV1ExamRevisionLangBotexamlangidFinishTranslation500
    >,
    {
      botExamLangId: PostApiV1ExamRevisionLangBotexamlangidFinishTranslationPathParams["botExamLangId"];
    },
    TContext
  >;
}
